import {checkAndSendCommentMails} from "./checkAndSendCommentMails";
import {getCommentContainerCodeHtml} from "./getCommentContainerCodeHtml";
import {getCommentCommentContainerCodeHtml} from "./getCommentCommentContainerCodeHtml";
import {dateToString} from "../utils/dateToString";
export function addComment(id, comment, parentCommentId) {
    if (shopUserId !== "") {
        var container = $("#commentModal_"+ id);
        var tmpCommunityType = 1;  // Standard type timeline
        var tmpId = id;
        if (container.hasClass("blog_entry")) {
            tmpCommunityType = 5;  // Blog
        } else if (container.hasClass("event_entry")) {
            tmpCommunityType = 6;  // Event
        } else if (container.hasClass("survey_entry")) {
            tmpCommunityType = 7;  // Survey
        } else if (container.hasClass("ideas_entry")) {
            tmpCommunityType = 8;  // Ideas
        } else if (id === 0 && parentCommentId !== 0) {
            tmpCommunityType = 0; // no type
        }

        $.ajax({
            type: "POST",
            url: "/module/community/ajax.php?action=add_comment",
            datatype: "json",
            data: {
                "ajax_call_id": tmpId,
                "ajax_call_comment": comment,
                "ajax_call_shop_user_id": shopUserId,
                "ajax_call_parent_comment_id": parentCommentId,
                "ajax_call_community_type": tmpCommunityType,
                "ajax_call_community_type_global": communityType,
                "ajax_call_main_language_id": mainLanguageId
            },
            success: function (output) {
                if (output !== "spam") {
                    var json = $.parseJSON(output);
                    var container = $(".timeline_entry#" + id);

                    var textChanged = "false";
                    if ($.trim(comment) !== json.cleaned_comment) {
                        textChanged = "true";
                    }

                    if (id === 0 && parentCommentId !== 0) {
                        container = $(".display_comment#comment_" + parentCommentId);
                        container.find(".comment_count_comment").text(json.count_comments);
                        container.find(".input_comment_comment").val("");
                        getCommentCommentContainerCodeHtml(json.cleaned_comment, dateToString(new Date(), true), parentCommentId, 'past', json.new_comment_id, json.community_user, "0", "0", textChanged);
                        shownComments[parentCommentId]++;
                    } else {
                        container.find(".comment_count").text(json.count_comments);
                        container.find(".input_comment").val("");
                        getCommentContainerCodeHtml(json.cleaned_comment, dateToString(new Date(), true), id, 'past', json.new_comment_id, json.community_user, "0", "0", tmpCommunityType, textChanged);
                        shownComments[id]++;
                    }
                    checkAndSendCommentMails(comment, tmpId, tmpCommunityType);
                } else {
                    $("#comment_spam_modal").modal("show");
                }
            }
        });
    }
}